import { MetadataExplainDTO } from "../models/services/AgenticMetadataDTO";
import { PageMetadata } from "../models/PageMetadata";

/** Effective tags + expedition out of a metadata/explain response. Unknown or empty values are dropped. */
export function toPageMetadata(dto: MetadataExplainDTO | undefined | null): PageMetadata {
    const effective = dto?.effective;
    const seen = new Set<string>();
    const tags = (effective?.tags ?? [])
        .filter((t) => !!t?.name && !seen.has(t.name) && !!seen.add(t.name))
        .map((t) => ({ name: t.name, source: t.source ?? "own", confidence: t.confidence ?? undefined }));

    const raw = effective?.scalars?.["expedition"]?.value;
    const expedition = typeof raw === "string" && raw.trim() ? raw.trim() : undefined;

    return { tags, expedition };
}
